import useQueryKeyBuilder from "api/hooks/useQueryKeyBuilder";

/**
 * Global hook to get the query key. This is used to generate the query key depends on widget and organization ids
 * @param key - Local key for react-query
 */
const useQueryKey = (key) => {
  const queryKeyBuilder = useQueryKeyBuilder();
  return queryKeyBuilder(key);
};

export default useQueryKey;
